import { AreaChart } from '@mantine/charts'
import { Text } from '@mantine/core'
import { IconChartLine } from '@tabler/icons-react'
import { EmptyState } from '@/components/ui'
import type { TrendPoint } from '@/api/security'

function fmtDate(iso: string | null): string {
  if (!iso) return '—'
  const d = new Date(iso)
  if (isNaN(d.getTime())) return '—'
  return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}`
}

interface TrendChartProps {
  points: TrendPoint[]
}

/** Curva REAL da postura ao longo dos scans — um ponto por scan concluído.
 *  Sem série chapada de 30 dias: com menos de 2 scans, EmptyState. */
export function TrendChart({ points }: TrendChartProps) {
  if (points.length < 2) {
    return (
      <EmptyState
        icon={IconChartLine}
        size="sm"
        title="Ainda sem histórico para uma curva"
        description="A evolução aparece a partir do segundo scan concluído. Rode mais um scan para começar a comparar."
      />
    )
  }

  const data = points.map((p) => ({
    date: fmtDate(p.completed_at),
    Total: p.total,
    Crítico: p.findings_by_severity?.critical ?? 0,
  }))

  return (
    <>
      <AreaChart
        h={260}
        data={data}
        dataKey="date"
        series={[
          { name: 'Total', color: '#025468' },
          { name: 'Crítico', color: '#e03131' },
        ]}
        curveType="linear"
        withDots
        gridAxis="xy"
      />
      <Text size="xs" c="dimmed" mt="xs">
        Curva real do histórico — {points.length} scan(s) concluído(s). Cresce ou cai a cada scan registrado.
      </Text>
    </>
  )
}
